import React, {useEffect, useState, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Col, Row} from 'reactstrap';
import IntlMessage from "../../helpers/intlMessage";
import {useIntl} from 'react-intl';
import CheckBox from '../../componentes/checkbox/checkbox.component';
import Switch from 'rc-switch';
import Table from './Table';
import * as commonActions from '@common/common.action';
import WebapiCommon from '../../app/common/util/webapi.common';
import TarefasApi from './tarefas.api';
import {getUsuarioLocalStorage} from '../../localStorage.util';

export default function ModalLiberacaoLote(props) {
  const intl = useIntl()
  const [modalAberto, setModalAberto] = useState(false);
  const [checkNumeroExame, setCheckNumeroExame] = useState(true);
  const [checkNumeroPedido, setCheckNumeroPedido] = useState(false);
  const [checkCertificarLaudos, setCheckCertificarLaudos] = useState(false);
  const [codigoLaudo, setCodigoLaudo] = useState("");
  const [cpfCertificado, setCpfCertificado] = useState("");
  const [pinCertificado, setPinCertificado] = useState("");
  const [placeholder, setPlaceHolder] = useState(intl.formatMessage({id: "dashboards.cytology.numberExam"}));
  const [lista, setLista] = useState([]);
  const campoCodigoRef = useRef();
  const campoCpfRef = useRef();
  const campoPinRef = useRef();
  const dispatch = useDispatch();
  const usuario = getUsuarioLocalStorage();

  useEffect(inicializarTela, [props.showModalLiberacaoLote]);
  useEffect(definirPlaceHolder, [checkNumeroExame, checkNumeroPedido]);
  useEffect(limparCamposCertificacao, [checkCertificarLaudos]);

  function inicializarTela() {
    setModalAberto(props.showModalLiberacaoLote);
    setLista([]);
  }

  function definirPlaceHolder() {
    if (checkNumeroExame)
      setPlaceHolder(intl.formatMessage({id: "dashboards.doctorTasks.examNumber"}))
    else
      setPlaceHolder(intl.formatMessage({id: "dashboards.doctorTasks.orderNumber"}))
  }

  function limparCamposCertificacao() {
    if (!checkCertificarLaudos) {
      setCpfCertificado("");
      setPinCertificado("");
    }
  }

  function toggle() {
    setModalAberto(!modalAberto);
    props.onModal(!modalAberto);
  }

  const onChangeCheckTipo = () => {
    setCheckNumeroExame(!checkNumeroExame)
    setCheckNumeroPedido(!checkNumeroPedido)
  }

  const validarCpf = (e) => {
    let _cpf = e;

		if (e.length === 11 && e.indexOf('.') < 0) {
			_cpf = _cpf
				.replace(/(\d{3})(\d)/, '$1.$2')
				.replace(/(\d{3})(\d)/, '$1.$2')
				.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
		} else if (e.length < 12) {
			_cpf = _cpf.replace(/(\d{3})(\d)/, '$1.$2');
		} else {
			_cpf = _cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
		}

		setCpfCertificado(_cpf);
  }

  const validarPin = (e) => {
		if (e.length > 6) {
			return;
		}

		setPinCertificado(e);
	}

  const removerDaLista = (e) => {
    let listaTemp = lista;
    let novaLista = listaTemp.filter(x => x.laudoid !== parseInt(e.target.id));

    setLista(novaLista);
  }

  const onClickInserir = () => {
    dispatch(commonActions.showFadeCarregando(true));

    TarefasApi.obterLaudoParaLiberacaoEmLote(codigoLaudo, checkNumeroExame, checkNumeroPedido).then(res => {
      let listaTemp = lista.map(x => ({...x}));
      let encontrado = listaTemp.find(x => x.laudoid === res.laudoId);

      if (encontrado) {
        dispatch(commonActions.showAlerta('alerta', intl.formatMessage({id: "dashboards.doctorTasks.orderAlreadyEntered"}), 2000));
        return;
      }

      let obj = {
        laudoid: res.laudoId,
        nrexame: res.nrExame,
        nrpedido: res.nrPedido,
        exame: res.exame,
        paciente: res.paciente,
        dataconclusao: res.dataConclusao
      };

      listaTemp.push(obj);
      setLista(listaTemp);
      setCodigoLaudo("");
      campoCodigoRef.current.focus();
    });

    dispatch(commonActions.showFadeCarregando(false));
  }

  const onKeyPressCampoCodigo = (event) => {
    if (event.key === 'Enter' && onClickInserir) {
      onClickInserir();
    }
  }

  const liberar = () => {
    dispatch(commonActions.showFadeCarregando(true));

    let listaDeId = lista.map((x) => {return x.laudoid});

    if (checkCertificarLaudos) {
      if (cpfCertificado == undefined || cpfCertificado == "") {
        dispatch(commonActions.showAlerta('alerta', intl.formatMessage({id: "dashboards.doctorTasks.enterYourSSN"}), 2000));
        dispatch(commonActions.showFadeCarregando(false));
        campoCpfRef.current.focus();
        return;
      }

      if (pinCertificado == undefined || pinCertificado == "") {
        dispatch(commonActions.showAlerta('alerta', intl.formatMessage({id: "dashboards.doctorTasks.enterYourPIN"}), 2000));
        dispatch(commonActions.showFadeCarregando(false));
        campoPinRef.current.focus();
        return;
      }

      let payload = {
        cpf: cpfCertificado,
        pin: pinCertificado,
        laudos: listaDeId
      };

      WebapiCommon.enviarCertificadosPendentesSelecionados(payload);
    }

    WebapiCommon.liberarLaudosEmLote(listaDeId, usuario.usuarioId).then(res => {
      let listaNaoLiberados = lista.filter(x => {
        return res.find(y => x.laudoid === y.laudoId && !y.sucesso);
      });

      let todosLiberados = listaNaoLiberados.length == 0;

      if (todosLiberados)
        dispatch(commonActions.showAlerta('sucesso', intl.formatMessage({id: "dashboards.doctorTasks.ordersReleasedSuccessfully"}), 2000));
      else {
        let alugnsLiberados = (res.length > 0) && res.some(x => x.sucesso);

        if (alugnsLiberados)
          dispatch(commonActions.showAlerta('alerta', intl.formatMessage({id: "dashboards.doctorTasks.partiallyReleasedOrders"}), 2000, `510px`));
        else
          dispatch(commonActions.showAlerta('erro', intl.formatMessage({id: "dashboards.doctorTasks.unreleasedOrders"}), 2000, `510px`));
      }

      setLista(listaNaoLiberados);
    })

    dispatch(commonActions.showFadeCarregando(false));
  }

  return (
    <Modal className='modal-xl' isOpen={modalAberto} toggle={toggle}>
      <ModalHeader toggle={!props.close ? toggle : props.close}>
        <IntlMessage id="dashboards.doctorTasks.releaseBatch"/>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col sm='auto' className='check-tipo'>
            <CheckBox
              label={<IntlMessage id="dashboards.doctorTasks.examNumber"/>}
              onChange={onChangeCheckTipo}
              checked={checkNumeroExame}
            ></CheckBox>
          </Col>
          <Col sm='auto' className='check-tipo'>
            <CheckBox
              label={<IntlMessage id="dashboards.doctorTasks.orderNumber"/>}
              onChange={onChangeCheckTipo}
              checked={checkNumeroPedido}
            ></CheckBox>
          </Col>
          <Col sm='auto' className='col-input-codigo'>
            <Input
              className='campo-codigo'
              innerRef={campoCodigoRef}
              placeholder={placeholder}
              onChange={(e) => {setCodigoLaudo(e.target.value)}}
              onKeyPress={onKeyPressCampoCodigo}
              value={codigoLaudo}
            />
          </Col>
          <Col sm='auto' className='btn-inserir'>
            <Button
              color='primary'
              disabled={!codigoLaudo}
              onClick={onClickInserir}
            >
              <IntlMessage id="dashboards.doctorTasks.insert"/>
            </Button>
          </Col>
        </Row>
        <Row className='certificacao'>
          <Col>
            <Switch
                name="certificarLaudos"
                className="custom-switch-certificar-laudos"
                checked={checkCertificarLaudos}
                onChange={() => {setCheckCertificarLaudos(!checkCertificarLaudos)}}
              />
              <label className='label-switch-certificar-laudos'>
                <IntlMessage id="dashboards.general.certification"/>
              </label>
          </Col>
        </Row>
        <Row>
          <Col sm='2' className='col-input-certificacao'>
            <label><IntlMessage id="dashboards.examDetails.cpf"/></label>
            <Input
              innerRef={campoCpfRef}
              type="text"
              maxLength="14"
              onChange={(e) => {validarCpf(e.target.value)}}
              value={cpfCertificado}
              disabled={!checkCertificarLaudos}
            />
          </Col>
          <Col sm='2' className='col-input-certificacao'>
            <label><IntlMessage id="dashboards.examDetails.pin"/></label>
            <Input
              innerRef={campoPinRef}
              type="number"
              onChange={(e) => {validarPin(e.target.value)}}
              value={pinCertificado}
              disabled={!checkCertificarLaudos}
            />
          </Col>
        </Row>
        <Table
          lista={lista}
          removerDaLista={removerDaLista}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={!props.cancelar ? toggle : props.cancelar}
          className={`button-cancel-liberacao-lote`}
          color='secondary'
        >
          <IntlMessage id="general.materialArchiving.close"/>
        </Button>
        <Button
          color='primary'
          disabled={!lista.length}
          onClick={liberar}
        >
          <IntlMessage id="general.materialArchiving.confirm"/>
        </Button>
      </ModalFooter>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/pages/tarefas/tarefas.liberacaolote.page.js